import { List } from 'immutable';
import { bulk as bulkSelections } from '../../selections/actions/update';
import addError from '../../../utils/error.jsx';

export function request(eventId, marketId, type, data) {
    return {
        type: 'MARKETS_ADD_DIVIDEND_REQUEST',
        dividendType: type,
        eventId,
        marketId,
        data
    };
}

export function error(marketId, errors) {
    addError(errors);

    return {
        type: 'MARKETS_ADD_DIVIDEND_ERROR',
        errors,
        marketId
    };
}

export function finish(marketId, market) {
    return (dispatch) => {
        dispatch(bulkSelections(market.selections));

        market.selections = market.selections.map(x => x.id);

        dispatch({
            type: 'MARKETS_ADD_DIVIDEND_FINISH',
            market,
            marketId
        });
    };
}
